import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { SEND_FORGOT_PASSWORD_EMAIL } from '@/utils/system_constants/constant.js';

const parse_api_data = (payload) => {
  if (typeof payload === 'string') {
    try {
      return JSON.parse(payload);
    } catch {
      return {};
    }
  }

  return payload || {};
};

const is_valid_email = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

export default {
  name: 'ForgotPassword',
  components: {
    OnboardingIndex
  },
  mixins: [alert_mixin],
  data() {
    return {
      email: '',
      verification_running: false
    };
  },
  methods: {
    async send_reset_email() {
      const email = this.email.trim();

      if (!email) {
        this.show_error('Email is required.');
        return;
      }

      if (!is_valid_email(email)) {
        this.show_error('Please enter a valid email address.');
        return;
      }

      this.verification_running = true;

      try {
        const response = await axios.post(SEND_FORGOT_PASSWORD_EMAIL, { email });
        const response_data = parse_api_data(response.data);

        if (response_data?.status && response_data.status !== 'success') {
          this.show_error(response_data.message || 'Failed to send reset email.');
          return;
        }

        this.show_success(response_data.message || 'Reset email sent.');
        this.$router.push({ name: 'UserLogin' });
      } catch (error) {
        const response_data = parse_api_data(error?.response?.data);
        this.show_error(
          response_data.message ||
          response_data.data ||
          error.message ||
          'Failed to send reset email.'
        );
      } finally {
        this.verification_running = false;
      }
    }
  }
};
